module.exports = __webpack_public_path__ + "img/餐饮banner.260479e3.png";